import { RouteId, RouteConfig } from '../../../types';
import LoginCardsContainer from '../LoginCards';
import CertificatesContainer from '../Certificates';
import ReportsContainer from '../Reports';

const routePrefix = '/print-screen';

const routes: RouteConfig[] = [
  {
    Component: LoginCardsContainer,
    path: `${routePrefix}/login-cards`,
    id: RouteId.PRINT_SCREEN,
    getTitle: () => '',
    privileges: []
  },
  {
    Component: CertificatesContainer,
    path: `${routePrefix}/certificates`,
    id: RouteId.PRINT_SCREEN,
    getTitle: () => '',
    privileges: []
  },
  {
    Component: ReportsContainer,
    path: `${routePrefix}/reports`,
    id: RouteId.PRINT_SCREEN,
    getTitle: () => '',
    privileges: []
  }
];

const getRoutes = (): RouteConfig[] => {
  return routes;
};

export default getRoutes;
